module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAH5JREFUeNpiZIACzqWZAUAqn4E4cIEFiaMAxA5EanRgROYBbcWlUQCI50NpMGAkZDTQMJDi/UBsAMQfYJqZSNTkCJNjIkXT9+jpF/BqJKQJq0ZiNGFoJFYTikZSNME1kqoJBFjI0DQBnACAGhuAdD2xNiE7FaTwACmaQAAgwABBaUDwVpbFjAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/module-analytics/components/up.png
// module id = 1689
// module chunks = 0